import styled, { css } from 'styled-components';

export const LowerWrapper = styled.div`
    margin: 5px;
    width: 650px;
    background: #fff;
    border: 1px solid #ddd;
`;

export const HeadingWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ddd;
    height: 50px;
    background: #f4f4f4;
`;

export const HeadingTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: left;

    h4 {
        font-size: 0.9rem;
        font-weight: 500;
        padding-left: 10px;
    }
`;

export const PrinterPanelInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const TextWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: left;
    padding-left: 10px;
    padding-top: 10px;
    h4 {
        font-size: 0.9rem;
        font-weight: 500;
        padding-left: 10px;
    }
`;

export interface IButtonProps {
    isSelected?: boolean;
    onClick?: () => void;
}

export const StyledButton = styled.button<IButtonProps>`
    font-size: 1em;
    margin: 3px;
    padding: 0.5em 1.5em;
    border-radius: 4px;
    outline: none;
    cursor: pointer;
    &.delete-btn {
        position: absolute;
        top: 0;
        left: 0;
    }
    &.primary-btn {
        background: #f4f4f4;
    }

    @media only screen and (max-width: 1280px) {
        font-size: 0.8rem;
        padding: 0.4em 0.8em;
    }

    ${({ isSelected }) =>
        !isSelected &&
        css`
            opacity: 0.25;
        `}

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.35;
        `}
`;
